import * as __model from '../model';
export class Counter{
    offerId?: number;
    offeredRate?: number;
    instructions?: string;
    isFinalOffer?: boolean;
  }